import { Component } from '@angular/core';
import { ToolbarPageLayoutService } from '../toolbar-page-layout/toolbar-page-layout.service';

@Component({
    selector: 'app-apt-toolbar',
    templateUrl: './apt-toolbar.component.html',
    styleUrls: ['./apt-toolbar.component.scss'],
    standalone: false
})

/**
 * @description: This is intended to be a very dumb wrapper that simply puts in the
 * necessary classes or styles for the underlying content. Though we are now more heavily relying on Bootstrap
 * classes this might serve no other purpose than simply add in the wrapper with its classes.
 */
export class AptToolbarComponent {
  constructor(public toolbarPageLayoutService: ToolbarPageLayoutService) {}
}
